/**
 * Verifica se o usuário tem acesso a pelo menos um dos recursos necessários.
 *
 * @param requirementsResources - Um array de strings dos recursos necessários para acesso.
 * @param userResources - Um Record onde as chaves são os nomes dos recursos que o usuário possui acesso.
 * @returns Um booleano indicando se o usuário tem acesso a pelo menos um recurso necessário.
 */
export const hasAccessTo = (
  requirementsResources: string[],
  userResources: Record<string, string[]> | null
): boolean => {
  if (!userResources) {
    return false;
  }
  const resourceNames = Object.keys(userResources);

  return requirementsResources.some((resource) =>
    resourceNames.includes(resource)
  );
};

/**
 * Verifica se o usuário tem a action necessária para pelo menos um dos recursos.
 * 
 * Hierarquia de permissões:
 * - "Editar" implica em "Visualizar" (quem pode editar, pode visualizar)
 * - "Visualizar" NÃO implica em "Editar"
 * @param requirementsResources - Um array de strings dos recursos necessários.
 * @param userResources - Um Record com os recursos e suas actions.
 * @param action - A action necessária ('Visualizar' ou 'Editar').
 * @returns Um booleano indicando se o usuário tem a permissão.
 */
export const hasAccessToAction = (
  requirementsResources: string[],
  userResources: Record<string, string[]>,
  action: string
): boolean => {
  return requirementsResources.some((resource) => {
    const userActions = userResources[resource];
    if (!userActions) {
      return false;
    }

    // Hierarquia: quem tem "Editar" também pode "Visualizar"
    if (action === 'Visualizar') {
      return userActions.includes('Visualizar') || userActions.includes('Editar');
    }

    return userActions.includes(action);
  });
};
